import IEmailVerifyResponse from '../components/Form/EmailCheck'

export interface IUserInfoState {
  salutation: string;
  firstName: string;
  lastName: string;
  workPhone: string;
  jobTitle: string;
  timeZone: string;
  emailAddress: string;
  personKey?: string;
  status?: string;
  userAccounts?: IEmailVerifyResponse[];
}

const UserInfoState: IUserInfoState = {
  salutation: '',
  firstName: '',
  lastName: '',
  workPhone: '',
  jobTitle: '',
  timeZone: '',
  emailAddress: '',
  personKey: '',
  status: ''
};

export interface IUserStatus {
  active: string;
  invited: string;
}

export const UserStatus: IUserStatus = {
  active: 'active',
  invited: 'invited'
};

export default UserInfoState;
